import React from 'react';
import { Avatar, Chip, IconButton, Menu, MenuItem  } from '@material-ui/core';
import { MoreVert as MoreIcon } from '@material-ui/icons';
import Moment from 'react-moment';
import styles from './index.module.scss';

const PostItem = (props: any) => {
    const { post } = props;
    const postTypeToColor: {[key: string]: string} = {
        "milestone": "#35CA01",
        "sign-off": "#E97000"
    };

    const getPostTypeColor = (type: string): string => {
        return postTypeToColor[type];
    }

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const onOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const onCloseMenu = () => {
        setAnchorEl(null);
    }

    const menuItems = [
        { label: 'Edit' }
    ]

    return (
        <div className={styles.container}>
            <div className={styles.postMeta}>
                <Avatar className={styles.avatar}>{post.user.initial}</Avatar>
                <div className={styles.user}>
                    <span className={styles.name}>{post.user.name}</span>
                    <span className={styles.meta}>
                        <Moment local format="hh:mm a">
                            {post.datetimestamp}
                        </Moment>
                    </span>
                </div>
            </div>
            <div className={styles.post}>
                <div className={styles.postHeader}>
                    <div className={styles.content}>
                        <div className={styles.eventType}>
                            {post.eventType}
                        </div>
                        <div className={styles.postTitle}>
                            <Chip style={{ backgroundColor: post.typeColor }} label={post.type}></Chip> 
                            <span className={styles.title}>{post.title}</span>
                        </div>
                    </div>

                    <div className={styles.actions}>
                        <IconButton aria-label="more" className={styles.moreButton} onClick={onOpenMenu}>
                            <MoreIcon />
                        </IconButton>
                        <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={onCloseMenu}>
                            {menuItems.map((item: any, i: number) => <MenuItem key={i}>{item.label}</MenuItem>)}
                        </Menu>
                    </div>
                </div>
                <div className={styles.postMessage}>
                    {post.message}
                </div>
            </div>
            <div className={styles.meta}>{post.readCount}/{post.totalCount} Read</div>
        </div>
    );
};

export default PostItem;